import '../chunk-YSKSG3AS.mjs';
import { getWagmiConnector } from '@binance/w3w-wagmi-connector';

var BinanceWalletConnector = class {
  constructor({ chains }) {
    this.id = "bsc";
    this.name = "Binance Web3 Wallet";
    const Connector = getWagmiConnector();
    const binanceConnector = new Connector({
      chains
    });
    this.binanceConnector = binanceConnector;
  }
};
function getBinanceWalletProvider({ chains }) {
  const binanceWalletConnector = new BinanceWalletConnector({ chains });
  return new Proxy(binanceWalletConnector, {
    get(target, propKey, receiver) {
      if (propKey === "name" || propKey === "id") {
        return Reflect.get(target, propKey);
      }
      if (propKey === "getProvider") {
        return binanceWalletConnector.binanceConnector.getProvider.bind(binanceWalletConnector.binanceConnector);
      }
      return Reflect.get(binanceWalletConnector.binanceConnector, propKey, binanceWalletConnector.binanceConnector);
    },
    set(target, prop, value, receiver) {
      return Reflect.set(binanceWalletConnector.binanceConnector, prop, value, binanceWalletConnector.binanceConnector);
    }
  });
}

export { BinanceWalletConnector, getBinanceWalletProvider };
